import { render, staticRenderFns } from "./OCrossTableTest.vue?vue&type=template&id=a713d36e&scoped=true&"
import script from "./OCrossTableTest.vue?vue&type=script&lang=js&"
export * from "./OCrossTableTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a713d36e",
  null
  
)

export default component.exports